import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataTransferService {

  private categories = new BehaviorSubject<any>({});
  private countries = new BehaviorSubject<any>({});
  public setCountryEvent = new BehaviorSubject<any>({});
  private refreshEvent = new BehaviorSubject<any>(null);
  private componentReload = new BehaviorSubject<boolean>(null);
  private merchantOfferEvent = new BehaviorSubject<any>(null);
  sharedCategories = this.categories.asObservable();
  sharedCountries = this.countries.asObservable();;
  sharedRefreshEvent = this.refreshEvent.asObservable();
  sharedMerchantOfferEvent = this.merchantOfferEvent.asObservable();


  constructor() { }

  nextCategories(categories) {
    this.categories.next(categories)
  }
  nextCountries(countries) {
    this.countries.next(countries)
  }

  nextRefreshEvent(refreshEvent) {
    this.refreshEvent.next(refreshEvent)
  }

  nextSelectedCountry(country) {
    this.setCountryEvent.next(country);
  }

  nextMerchantOfferData(data) {
    this.merchantOfferEvent.next(data);
  }

}
